import { MemberMedicalQuestion } from './member-medical-question.model';

export class MemberMedicalAnswer {
    MemberId: number;
    MemberMedicalQuestionId: number;
    Answer?: boolean;

    MedicalQuestion: MemberMedicalQuestion;
}